import {
  TOGGLE_EDIT_PASSWORD_MODAL,
  TOGGLE_GENERATE_PROMOCODES_MODAL,
  TOGGLE_REGISTER_USER_MODAL
} from '../actions/types'

const INITIAL_STATE = {
  registerUser: {
    isOpen: false
  },
  editPassword: {
    isOpen: false
  },
  generatePromoCodes: {
    isOpen: false
  }
}

export const ModalsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TOGGLE_EDIT_PASSWORD_MODAL:
      return {
        ...state,
        editPassword: {
          ...state.editPassword,
          isOpen: !state.editPassword.isOpen
        }
      }
    case TOGGLE_GENERATE_PROMOCODES_MODAL:
      return {
        ...state,
        generatePromoCodes: {
          ...state.generatePromoCodes,
          isOpen: !state.generatePromoCodes.isOpen
        }
      }
    case TOGGLE_REGISTER_USER_MODAL:
      return {
        ...state,
        registerUser: {
          ...state.registerUser,
          isOpen: !state.registerUser.isOpen
        }
      }
    default:
      return state
  }
}
